/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1CourseregistrationSharedStatusReasonListQueryResponse,
  GetApiV1CourseregistrationSharedStatusReasonListQueryParams,
  GetApiV1CourseregistrationSharedStatusReasonList401,
  GetApiV1CourseregistrationSharedStatusReasonList500,
} from "../../types/courseRegistrationSharedController/GetApiV1CourseregistrationSharedStatusReasonList.ts";

function getGetApiV1CourseregistrationSharedStatusReasonListUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/courseregistration/shared/status-reason-list` as const,
  };
  return res;
}

/**
 * @description Retorna os motivos de status ativos filtrados pelo tipo de status de matrícula informado. Para status Cancelado ou CanceladoNaMatrícula retorna motivos do tipo Cancelamento; para status Rejeitado retorna motivos do tipo Rejeição; para os demais status retorna todos os motivos ativos. **(Requer Authorization para autenticação)**
 * @summary Retorna a lista de motivos de status para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/shared/status-reason-list}
 */
export async function getApiV1CourseregistrationSharedStatusReasonList(
  params?: GetApiV1CourseregistrationSharedStatusReasonListQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1CourseregistrationSharedStatusReasonListQueryResponse,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationSharedStatusReasonList401
      | GetApiV1CourseregistrationSharedStatusReasonList500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1CourseregistrationSharedStatusReasonListUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
